import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'

export const identityValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const certificateId = control.get('certificateId')
    const tattooId = control.get('tattooId')
    const rfid = control.get('rfid')
    return !certificateId.value && !tattooId.value && !rfid.value ? { atLeastOne: true } : null
}
